import type { ReactNode } from 'react'
import listStyles from '@/styles/pages/governance/GovernanceListing.module.scss'

const rowClass = `${listStyles.row} ${listStyles.rowEmpty}`

export function TableLoadingRow({ colSpan, children }: { colSpan: number; children: ReactNode }) {
  return (
    <tr className={rowClass} role="status">
      <td className={`${listStyles.td} ${listStyles.tdLoading}`} colSpan={colSpan}>
        {children}
      </td>
    </tr>
  )
}

export function TableErrorRow({ colSpan, children }: { colSpan: number; children: ReactNode }) {
  return (
    <tr className={rowClass} role="alert">
      <td className={`${listStyles.td} ${listStyles.tdError}`} colSpan={colSpan}>
        {children}
      </td>
    </tr>
  )
}

export function TableEmptyRow({
  colSpan,
  children,
  className,
}: {
  colSpan: number
  children: ReactNode
  className?: string
}) {
  return (
    <tr className={rowClass} role="status">
      <td className={[listStyles.td, listStyles.tdEmpty, className].filter(Boolean).join(' ')} colSpan={colSpan}>
        {children}
      </td>
    </tr>
  )
}
